// ─── Live-Call Auth Catalog Data Models ──────────────────────────────────────
//
// The UNIVERSAL credentials entries live-call tools reference: a name, the base
// URL they authenticate against, an auth scheme, and a write-only token. Not
// product-scoped, and every entry is visible in BOTH the test and production
// deployments (the backend pins for_env=3) — there is no environment selector.
// Responses never carry the token itself, only hasToken + a 4-char suffix.

/** One row of the live_call_auth catalog (token masked). */
export interface LiveCallAuthConfig {
  id: number;
  name: string;
  baseUrl: string;
  /** One of: none | bearer | api_key | basic | oauth2 | access_token. */
  authType: string;
  /** Whether a secret is stored. The raw value is write-only. */
  hasToken: boolean;
  /** Last 4 characters of the stored token, or null. */
  tokenSuffix: string | null;
  isActive: boolean;
  /** Always 3 (both) — auth entries are universal. */
  forEnv: number;
  createdAt?: string | null;
  updatedAt?: string | null;
}

export interface LiveCallAuthListResponse {
  count: number;
  authConfigs: LiveCallAuthConfig[];
}

/** Body for POST — add one entry. 409 if `name` already exists. */
export interface CreateLiveCallAuthPayload {
  name: string;
  base_url: string;
  auth_type: string;
  token?: string | null;
  is_active?: boolean;
}

/** Body for PATCH — all optional. `token: null` clears the secret; omit to keep it. */
export interface PatchLiveCallAuthPayload {
  name?: string;
  base_url?: string;
  auth_type?: string;
  token?: string | null;
  is_active?: boolean;
}

/** Auth scheme choices for the form dropdown (mirrors the backend whitelist). */
export const AUTH_TYPE_OPTIONS: ReadonlyArray<{ value: string; label: string }> = [
  { value: 'none', label: 'None (public API)' },
  { value: 'bearer', label: 'Bearer token' },
  { value: 'api_key', label: 'API key' },
  { value: 'basic', label: 'Basic auth' },
  { value: 'oauth2', label: 'OAuth 2.0' },
  { value: 'access_token', label: 'Access token' },
];
